import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useUserStore } from "@roc/feature-app-core";
import { useEffect, useState } from 'react';
import { Box, Grid, Typography, Menu, IconButton, MenuItem, TextField } from '@material-ui/core';
import { Button, MultiSelectField, createSelectField } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { alertCircleOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import { templatePlaceHolders } from 'libs/feature-communication/src/communication/utils/constants';
import { Code } from '@material-ui/icons';




const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(3, 0, 4),
      borderRadius: theme.spacing(2),
      boxShadow:
        'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
      display: 'flex',
      justifyContent: 'center',
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
    },
    modalContainer: {
      width: '100%',
      maxWidth: '800px',
      margin: '0 auto',
      overflow: 'hidden',
    },
    buttonContainer: {
      paddingTop: theme.spacing(4),
    },
    contentContainer: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    title: {
      paddingLeft: theme.spacing(2),
      display: 'flex',
      justifyContent: 'flex-start',
    },
    attachmentButtonContainer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      height: '30px'
    },
    textMessage: {
      borderRadius: 15,
      borderTopLeftRadius: 0,
      backgroundColor: '#90EE90',
      display: 'inline-block',
      maxWidth: '100%',
      minWidth: '100%',
      maxHeight: '250px',
      minHeight: '250px',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      boxSizing: 'border-box',
      padding: '8px',
      overflowY: 'auto',
      paddingRight: '15px',
      marginTop: '30px'
    },
  })
);

const currentPath = window.location.pathname;

export const SendMessagesChannelForm = observer(({ handleClose = () => { }, salesforceLeadStore, type, fromGrid, stepToEdit }) => {
  const classes = useStyles();
  const { ringCentralStore, createListStore } = salesforceLeadStore;
  const { createListFormStore } = createListStore;
  const { userStore, globalStore, cadenceStore } = useStore();
  const { cadenceForm } = cadenceStore;
  const { userStore: { userInformation } } = useUserStore();
  const [placeHolderMenu, setPlaceHolderMenu] = useState(false);
  const [anchorPlaceHolderElement, setAnchorPlaceHolderElement] = useState<null | HTMLElement>(null);
  // const [sendTo, setSendTo] = useState([]);


  const setupTextEdition = () => {
    cadenceForm.onFieldChange('content', stepToEdit.stepContent.content || '');
    cadenceForm.onFieldChange('stepNumber', stepToEdit.stepNumber || '');
  }

  useEffect(() => {
    if (stepToEdit?.stepContent) {
      setupTextEdition();
    } else {
      cadenceForm.reset();
    }
  }, [stepToEdit]);

  const portalId = salesforceLeadStore.portalId || userStore.userInformation.portalId;
  const userId = salesforceLeadStore.userId || userStore.userInformation.userId;
  //const connectedWithRingCentral = salesforceLeadStore.isSalesForce ? salesforceLeadStore.connectedWithRingcentral : userInformation.connectedWithRingcentral;

  const handleMenuOpen = (event) => {
    setAnchorPlaceHolderElement(event.currentTarget);
    setPlaceHolderMenu(true);
  }

  // async function handleOnClick() {
  //   await ringCentralStore.getCreds();
  //   const host = await salesforceLeadStore.getHostByPortaId(portalId);
  //   ringCentralStore.retriveTokenWithOAuthToken(userId, host);
  // }

  // useEffect(() => {
  //   currentPath.includes("/backoffice") && createListFormStore.onFieldChange('objectType', 'Lead');
  //   createListStore.getFilterCriteriaOptions();
  //   ringCentralStore.getSmsCount();
  //   ringCentralStore.getAllTemplates();
  //   ringCentralStore.initSentToOptions(type);
  // }, []);

  useEffect(() => {
    const lead = salesforceLeadStore.getLeadForEmailPreview();
    ringCentralStore.updatePreview(cadenceForm.form.fields.content.value, userStore.userInformation, lead);
  }, [
    cadenceForm.form.fields.content.value,
  ]);

  // useEffect(() => {
  //   createListStore.setFilterCriteriaOptions(createListStore.createListFormStore.form.fields.objectType.value)
  // }, [createListStore.createListFormStore.form.fields.objectType.value, createListStore.filterCriteriaOptions]);

  const onEditorChange = (value: string) => {
    cadenceForm.onFieldChange('content', value);
  }


  return (
    <Grid container spacing={4}>
      <Grid item style={{ flex: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Text Message</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid className={classes.attachmentButtonContainer}>
              <IconButton onClick={handleMenuOpen}>{<Code />}</IconButton>
            </Grid>
            <Menu
              anchorEl={anchorPlaceHolderElement}
              open={placeHolderMenu}
              onClose={() => setPlaceHolderMenu(false)}
            >
              {templatePlaceHolders.map(placeHolder => (
                <MenuItem key={placeHolder} onClick={() => {
                  setPlaceHolderMenu(false);
                  cadenceForm.onFieldChange(
                    'content',
                    `${cadenceForm.form.fields.content.value} ${placeHolder}`
                  );
                }}>
                  {placeHolder}
                </MenuItem>
              ))}
            </Menu>
            <TextField
              id="message"
              variant="outlined"
              placeholder="Message"
              inputProps={{ maxLength: 160 }}
              value={cadenceForm.form.fields.content.value}
              onChange={(e) => onEditorChange(e.target.value)}
              multiline
              fullWidth
              minRows={10}
              maxRows={10}
            />
          </Grid>
        </Grid>
      </Grid>
      {!!ringCentralStore.previewHtml && (
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Preview</Typography>
            </Grid>
            <Grid item xs={12}>
              <Box p={2} className={classes.textMessage}>
                {ringCentralStore.previewHtml}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
});

export const SendMessagesCadenceModal = observer(({ handleClose, salesforceLeadStore, type, fromGrid = false, stepToEdit }) => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="center" alignItems='center' className={classes.modalContainer}>
      <SendMessagesChannelForm handleClose={handleClose} salesforceLeadStore={salesforceLeadStore} type={type} fromGrid={fromGrid} stepToEdit={stepToEdit} />
    </Grid>
  )
});